export interface OrganizationUnit {
  _id: string;
  name: string;
  description: string;
  status: string;
  /**
   * Per (program, org unit) flag from GET users/:id/programs.
   * false => the pair is locked: it has >=1 Active participant and no other
   * active Officer is assigned to it, so the user cannot unassign it.
   */
  canUncheck?: boolean;
}

export interface Programs {
  orgUnitIds: OrganizationUnit[];
  _id: string;
  accountId: string;
  name: string;
  status: string;
  eventName: string;
  parameters: ProgramParameters;
  orgUnitId: string[];
  createdAt: Date;
  createdBy: string;
  isDeleted: boolean;
}

export interface ProgramParameters {
  requiresCaseNumber: boolean;
  maxNumberClients: number;
  starDate: Date;
  endDate: Date;
}

export type ProgramStatus = "PENDING" | "ACTIVE" | "COMPLETED" | "CANCELED";

export const PROGRAM_STATUSES: ProgramStatus[] = [
  "PENDING",
  "ACTIVE",
  "COMPLETED",
  "CANCELED",
];

// Matches the API contract exactly. NOTE: the start-date key is the
// misspelled "starDate" (no 't') — that is the stored field name.
export interface ProgramParametersPayload {
  requiresCaseNumber: boolean;
  maxParticipants: number;
  starDate: string;
  endDate?: string;
}

export interface Program {
  _id: string;
  id: string;
  accountId: string;
  name: string;
  status: ProgramStatus;
  eventName?: string;
  orgUnitId: string[];
  parameters?: ProgramParametersPayload;
  isDeleted: boolean;
  createdAt: string;
  updatedAt?: string;
  createdBy: string;
  updatedBy?: string;
}

export type ProgramPayload = {
  name: string;
  status: ProgramStatus;
  orgUnitId: string[];
  eventName?: string;
  parameters?: ProgramParametersPayload;
  createdBy?: string;
  updatedBy?: string;
};
